import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  users:any;
  userEdit: any;
  loading: any;


  constructor( private authService: AuthenticationService) { }

  ngOnInit(): void {
    this.getUsers();
  }

  getUsers(){
    this.loading = true;
    this.authService.getUsers().then(res=>{
      this.users = res;
      console.log(res);
      this.loading = false;
    }, err=>{
      this.loading = false;
    })
  }

  userDetails(user:any){
    this.userEdit = user;
  }

}
